// extracted by mini-css-extract-plugin
module.exports = {"light":"Wrapper_light__2kqR9","card":"Wrapper_card__12Oi0","loaderBlock":"Wrapper_loaderBlock__1bbuz","noData":"Wrapper_noData__3P0gV","sourceList":"Wrapper_sourceList__2BTx3"};